/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Ledger_Tab_LayoutInputs */

const fr_api_ledger_tab_layout = /** @type {(inputs: Api_Ledger_Tab_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet onglet n’a pas la mise en page de la retenue. Choisissez un onglet vide ou un onglet qui commence par Année, Mois, Prestataires, Numéro de la facture.`)
};

const en_api_ledger_tab_layout = /** @type {(inputs: Api_Ledger_Tab_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That tab is not laid out as the withholding ledger. Choose an empty tab or one starting with Année, Mois, Prestataires, Numéro de la facture.`)
};

/**
* | output |
* | --- |
* | "That tab is not laid out as the withholding ledger. Choose an empty tab or one starting with Année, Mois, Prestataires, Numéro de la facture." |
*
* @param {Api_Ledger_Tab_LayoutInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_ledger_tab_layout = /** @type {((inputs?: Api_Ledger_Tab_LayoutInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Ledger_Tab_LayoutInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_ledger_tab_layout(inputs)
	return fr_api_ledger_tab_layout(inputs)
});